import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { AlertService, LoaderEnabled } from 'sce-core';
import { ResourceService } from 'sce-core';
import { UserService } from '../../core/security/user.service';
import { ModalService } from './modal.service';
import { SearchableEntityDataService } from './searchable-entity/searchable-entity-data.service';
import { SearchService } from '../search/search.service';
import { JreportLookupComponent } from '../lookup/jreport-lookup/jreport-lookup.component';
import { Subscription } from 'rxjs/Subscription';
import { COMMON_FIELDS } from '../../constants';

@Injectable()
export class JReportPrinterService {

  protected hasAdditionalFields: Boolean = false;
  public printerId: any;
  public printReportSubscribtion: Subscription;
  public parentDataService: SearchableEntityDataService;
  public tableSearchServiceForWaveControl: SearchService;
  public data: any;
  constructor(protected http$: HttpClient,
    protected alertService: AlertService,
    protected modalService: ModalService,
    protected resourceService: ResourceService,
    protected userService: UserService) { }

  /* [LFWM-2027] - documnetType - tableid
  * storer - storerkey value from parent screen
  * facility - facility value from parent screen
  * dataService - dataService of parent screen
  * primaryDataMap - primaryDataMap from parent screen
  * tableSearchService - its a optional parameter - [for wave control screen - tableSearchService is passed from wave control
    screen because which has more than one detail search service and detail table.
  */
  public printReport(documentType: string, storer: string,
    facility: string, primaryDataMap: any, dataService: any, tableSearchService?: any) {
    this.parentDataService = dataService;
    this.tableSearchServiceForWaveControl = tableSearchService;
    let tempList = [];
    const reportDefaultValues = {
      'documentType': documentType,
      'storer': storer,
      'facility': facility,
    };
    this.getModuleReport(reportDefaultValues)
      .subscribe((resp: any) => {
        const dataToRemove: Array<string> = [
          'ExtendedParmDefault1',
          'ExtendedParmDefault2',
          'ExtendedParmDefault3',
          'ExtendedParmDefault4',
          'ExtendedParmDefault5',
          'ReportTitle',
          'NeedExtendedParm'];
        Object.keys(resp)
          .forEach((key: string) => {
            if (dataToRemove.indexOf(key) !== -1) {
              delete resp[key];
            }
          });
        tempList = <any[]>resp;
        if (this.userService.userInfo.defaultPrinter) {
          this.printerId = this.userService.userInfo.defaultPrinter;
          this.invokePrintModal(tempList, reportDefaultValues,
            this.printerId, primaryDataMap, false, null, 'DocReport', null);
        } else {
          this.userService.fetchDefaultPrinter()
            .subscribe((printeresp: any) => {
              this.printerId = printeresp;
              this.invokePrintModal(tempList, reportDefaultValues,
                this.printerId, primaryDataMap, false, null, 'DocReport', null);
            });
        }
      }, (err: any) => {
        this.alertService.clearAll()
          .error(this.resourceService.translateServerResponse(err));
      });
  }

  public printSearchReport(documentType: string, storer: string,
    facility: string, primaryDataMap: any, dataService: any,selectedShipRefKeys: any, useBackendForJReportPrinting:boolean, tableSearchService?: any) {
    this.parentDataService = dataService;
    this.tableSearchServiceForWaveControl = tableSearchService;
    let tempList = [];
    const reportDefaultValues = {
      'documentType': documentType,
      'storer': storer,
      'facility': facility,
    };
    this.getModuleReport(reportDefaultValues)
      .subscribe((resp: any) => {
        const dataToRemove: Array<string> = [
          'ExtendedParmDefault1',
          'ExtendedParmDefault2',
          'ExtendedParmDefault3',
          'ExtendedParmDefault4',
          'ExtendedParmDefault5',
          'ReportTitle',
          'NeedExtendedParm'];
        Object.keys(resp)
          .forEach((key: string) => {
            if (dataToRemove.indexOf(key) !== -1) {
              delete resp[key];
            }
          });
        tempList = <any[]>resp;
        this.userService.fetchDefaultPrinter()
          .subscribe((printeresp: any) => {
            this.printerId = printeresp;
            this.invokeSearchPrintModal(tempList, reportDefaultValues,
            this.printerId, primaryDataMap, false, null, 'DocReport', null, selectedShipRefKeys,useBackendForJReportPrinting);
        });
       
      }, (err: any) => {
        this.alertService.clearAll()
          .error(this.resourceService.translateServerResponse(err));
      });
  }

  public invokeSearchPrintModal(reportConfig: any, inputValues: any,
    printerIds: any, primaryDataMap: any, showKeyValueParams: any,
    dataEditor: any, source: any, keyEventHandler: any,selectedShipRefKeys: any,useBackendForJReportPrinting: boolean) {
    this.alertService.clearAll();    
    if (this.printReportSubscribtion) {
      this.printReportSubscribtion.unsubscribe();
    }    

    const modalRef: any = this.modalService
      .showModal(JreportLookupComponent,
        {
          overlayHeader: this.resourceService.get('btn_label_jreport'),
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 600
        });
    if (dataEditor) {
      modalRef.content.setDataTableEditor(dataEditor, keyEventHandler);
    }
    modalRef.content.setInitialData(reportConfig, inputValues,
      printerIds, primaryDataMap, showKeyValueParams, source, this.parentDataService, this.tableSearchServiceForWaveControl);
      this.printReportSubscribtion =  modalRef.content.jReportprintReportReceiveEvent()
      .subscribe((requestData: any) => {
        if (useBackendForJReportPrinting) {
          requestData[0].printSource = 'JReportBE';
        }
        const payload = selectedShipRefKeys.length === 1 ? requestData : this.generatePrintPayload(requestData, selectedShipRefKeys);       
        this.submitPrintReport(payload)
          .subscribe((response: any) => {
            if (response.statusCode === 200 && response.printresp) {
              let printresp = response.printresp[0];
              //Handling success case
              if (printresp.success === 200
                && printresp.successMessage === 'Successful') {                  
                  this.alertService.clearAll().success(this.resourceService.get('msg_prnt_succ'));
                  modalRef.hide();
              } else {
                this.alertService.clearAll().error(this.resourceService.translateServerResponse(printresp.errorMsg));
                modalRef.hide();
              }
            } else {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(response.statusMessage));
              modalRef.hide();
            }

          }, (err) => {
            this.alertService.clearAll().error(this.resourceService.translateServerResponse(err));
            modalRef.hide();

          });
      });
  }

  // Helper method to generate payload
  private generatePrintPayload(requestData: any, primaryKeys: any): any {
    return requestData.flatMap((item: any) =>
        primaryKeys.map((id: string) => {
            const updatedPrintParams = item.printParams.map((param: any) =>
                param.displayLabel === 'mbolkey' || param.displayLabel === COMMON_FIELDS.RECEIPT_KEY ? { ...param, value: id } : param
            );
            return { ...item, printParams: updatedPrintParams };
        })
    );
  }

  public printFromViewReportScreen(reportConfig: any,
    rowDataMap: any, dataEditor: any, keyEventHandler: any) {
    if (this.userService.userInfo.defaultPrinter) {
      this.printerId = this.userService.userInfo.defaultPrinter;
      this.invokePrintModal(reportConfig, rowDataMap, this.printerId,
        rowDataMap, true, dataEditor, 'ViewReport', keyEventHandler);
    } else {
      this.userService.fetchDefaultPrinter()
        .subscribe((printeresp: any) => {
          this.printerId = printeresp;
          this.invokePrintModal(reportConfig, rowDataMap, this.printerId,
            rowDataMap, true, dataEditor, 'ViewReport', keyEventHandler);
        });
    }
  }

  public invokePrintModal(reportConfig: any, inputValues: any,
    printerIds: any, primaryDataMap: any, showKeyValueParams: any,
    dataEditor: any, source: any, keyEventHandler: any) {
    this.alertService.clearAll();
    const modalRef: any = this.modalService
      .showModal(JreportLookupComponent,
        {
          overlayHeader: this.resourceService.get('btn_label_jreport'),
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 600
        });
    if (dataEditor) {
      modalRef.content.setDataTableEditor(dataEditor, keyEventHandler);
    }
    modalRef.content.setInitialData(reportConfig, inputValues,
      printerIds, primaryDataMap, showKeyValueParams, source, this.parentDataService, this.tableSearchServiceForWaveControl);
    modalRef.content.jReportprintReportReceiveEvent()
      .subscribe((requestData: any) => {
        console.log('requestData', requestData);
        /** Add URL fetch API here */
        /** Sample response format
         * {
              "printresp": [
                  {
                      "error": 0,
                      "errorMsg": null,
                      "success": 200,
                      "successMessage": "Successful",
                      "rowNo": 1,
                      "reportId": "R000000011",
                      "detailRowId": 47,
                      "reportURL": "https://lflreportdev.lfuat.net/jinfonet/tryView.jsp?jrs.report=/China/WMS%20UAT/PB/RPT_NSP_PVH_POD_DY.cls&jrs.catalog=/China/WMS%20UAT/CN_WMS_UAT.cat&jrs.result_type=2&jrs.param$PARAM_WMS_c_Mbolkey="
                  }
              ],
              "statusCode": 200,
              "statusMessage": "SUCCESS"
          }
         */
        this.submitPrintReport(requestData)
          .subscribe((response: any) => {
            if (response.statusCode === 200 && response.printresp) {
              let printresp = response.printresp[0];
              //Handling success case
              if (printresp.success === 200
                && printresp.successMessage === 'Successful') {
                if (printresp.reportURL) {
                  // console.log("requestData",requestData[0])
                  this.data = requestData[0];
                  this.data.iframeUrl = printresp.reportURL;
                  const reportId = this.data.reportID;
                  modalRef.hide();
                  this.parentDataService.buttonService.submitJreport(reportId);
                } else {
                  this.alertService.clearAll().error(this.resourceService.get('jreport_url_not_available'));
                  modalRef.hide();
                }
              } else {
                this.alertService.clearAll().error(this.resourceService.translateServerResponse(printresp.errorMsg));
                modalRef.hide();
              }
            } else {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(response.statusMessage));
              modalRef.hide();
            }

          }, (err) => {
            this.alertService.clearAll().error(this.resourceService.translateServerResponse(err));
            modalRef.hide();

          });
      });
  }

  @LoaderEnabled()
  public getModuleReport(reportDefaultValues: any) {
    let reportType;
    if(reportDefaultValues.documentType == 'invmovetd'){
      reportType = 'PrintMoveLabel';
    }else{
      reportType = "";
    }
    const request = {
      'documentType': reportDefaultValues.documentType,
      'storerkey': reportDefaultValues.storer,
      'facility': reportDefaultValues.facility,
      'computerName': '',
      'printSource': 'JReport',
      "reportType": reportType
    };

    const response$ = this.http$.post('api/report/module/report', JSON.stringify(request))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0 && error.error.statusCode !== 200) {
          return Observable.throw(error.error.statusMessage);
        }
      });
    return response$;
  }

  @LoaderEnabled()
  public submitPrintReport(printReportInput: any) {
    console.log('printReportInput', printReportInput);
    // LFWM-1811 : Print service url change
    const response$ = this.http$.post('api/report/print', JSON.stringify(printReportInput))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0 && error.error.statusCode !== 200 ) {
          return Observable.throw(error.error.statusMessage);
        }
      });
    return response$;
  }

  public getViewReportDetails(reportType: any) {
    const request = {
      'moduleID': 'ViewReport',
      'reportID': reportType.trim()
    };
    const response$ = this.http$.post('api/report/viewReport/params', JSON.stringify(request))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0 && error.error.statusCode !== 200) {
          return Observable.throw(error.error.statusMessage);
        }
      });
    return response$;
  }
  
  public submitViewReportPrint(printReportInput) {
    const response$ = this.http$.post('api/report/viewReport/print', JSON.stringify(printReportInput))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0 && error.error.statusCode !== 200) {
          return Observable.throw(error.error.statusMessage);
        }
      });
    return response$;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/jreport-printer.service.ts